import type { App } from "vue"
import type { ModuleDefinition, ModuleOptions } from "@core/types/module"

const homeModule: ModuleDefinition = {
    name: "home",

    install(_app: App, _options: ModuleOptions): void {},
}

export default homeModule
